/**
 * Registers the offline worker (sw/offline-worker.js, served as /sw.js by the
 * production build). It only answers page loads that fail without a
 * connection, so the portal works the same when registration fails.
 * `updateViaCache: 'none'`: every update check asks the network, never the
 * HTTP cache, so a new deploy's worker is found on the next visit.
 */
export function registerOfflineWorker(enabled: boolean = import.meta.env.PROD): void {
  if (!enabled || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const register = () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch((e: unknown) => console.warn('[portal] offline page unavailable: service worker not registered', e));
  };
  // After the page has loaded, so the worker never competes with the first paint.
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
